import { CSSProperties } from 'react';

export const container: CSSProperties = {
  bottom: 80,
  position: 'fixed',
  right: 35,
  zIndex: 9999,
};

export const image1: CSSProperties = {
  cursor: 'pointer',
  height: 40,
  width: 40,
};
